import { useEffect, useMemo } from "react";

export function useTypedBlobUrl(
  blob: Blob | null,
  fallbackUrl: string | null,
  mime: string,
): string | null {
  const url = useMemo<string | null>(() => {
    if (!blob || !fallbackUrl) return null;
    if (blob.type === mime) return fallbackUrl;
    const retyped = new Blob([blob], { type: mime });
    return URL.createObjectURL(retyped);
  }, [blob, fallbackUrl, mime]);

  useEffect(() => {
    if (!url || url === fallbackUrl) return;
    return () => {
      URL.revokeObjectURL(url);
    };
  }, [url, fallbackUrl]);

  return url;
}
